// import React, { useState, useEffect,useRef } from 'react';
// import '../Components/CSS/Login.css';
// import { useAuth } from '../Components/Authcontext';

// function Login() {
//     const [username, setUsername] = useState("");
//     const [password, setPassword] = useState("");
//     const { login } = useAuth(username, password);

//     const handleSubmit = (e) => {
//        login(username,password);
  
    
//     };


//   return (
//     <div className="login-container">
//     <div className="login-form">
//       <h2 className="login-heading">Login</h2>
//       <form onSubmit={handleSubmit}>
//         <input
//           type="text"
//           className="input-field"
//           placeholder="Username"
//           value={username}
//           onChange={(e) => setUsername(e.target.value)}
//         />
//         <input
//           type="password"
//           className="input-field"
//           placeholder="Password"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//         />
//         <button type="submit" className="submit-button">
//           Login
//         </button>
//       </form>
//     </div>
//   </div>
//   )
// }

// export default Login  



import React, { useState } from "react";
import { useAuth } from "../Components/Authcontext";
import background from "../img/Login.jpg";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { login } = useAuth();

  const handleSubmit = (e) => {
    e.preventDefault();
    login(username, password);
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundImage: `url(${background})` ,
        fontFamily: "Poppins, sans-serif",
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "2.5rem",
          borderRadius: "16px",
          boxShadow: "0 8px 25px rgba(0, 0, 0, 0.2)",
          width: "350px",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            fontSize: "1.8rem",
            fontWeight: "600",
            marginBottom: "0.5rem",
            color: "#333",
          }}
        >
          Welcome Back 👋
        </h2>
        <p style={{ fontSize: "0.95rem", color: "#777", marginBottom: "1.5rem" }}>
          Please sign in to continue
        </p>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Enter Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={{
              width: "100%",
              padding: "12px 15px",
              margin: "10px 0",
              border: "1px solid #ddd",
              borderRadius: "10px",
              fontSize: "1rem",
              outline: "none",
            }}
            onFocus={(e) =>
              (e.target.style.border = "1px solid #667eea")
            }
            onBlur={(e) =>
              (e.target.style.border = "1px solid #ddd")
            }
          />
          <input
            type="password"
            placeholder="Enter Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{
              width: "100%",
              padding: "12px 15px",
              margin: "10px 0",
              border: "1px solid #ddd",
              borderRadius: "10px",
              fontSize: "1rem",
              outline: "none",
            }}
            onFocus={(e) =>
              (e.target.style.border = "1px solid #667eea")
            }
            onBlur={(e) =>
              (e.target.style.border = "1px solid #ddd")
            }
          />
          <button
            type="submit"
            style={{
              width: "100%",
              padding: "12px",
              marginTop: "15px",
              background: "linear-gradient(135deg, #667eea, #764ba2)",
              color: "#fff",
              border: "none",
              borderRadius: "10px",
              fontSize: "1rem",
              fontWeight: "500",
              cursor: "pointer",
              transition: "0.3s",
            }}
            onMouseOver={(e) =>
              (e.target.style.background =
                "linear-gradient(135deg, #5a67d8, #6b46c1)")
            }
            onMouseOut={(e) =>
              (e.target.style.background =
                "linear-gradient(135deg, #667eea, #764ba2)")
            }
          >
            Login
          </button>
        </form>

        <div style={{ marginTop: "1rem" }}>
         
           
        </div>
      </div>
    </div>
  );
}

export default Login;
